import { memo } from "react";
import { ICONS } from "../../utils/iconUtil";
import SvgIcon from "../../shared/Components/UI/Svg";

const Icon = ({
  name,
  className,
  size = 15,
  cursorPointer = false,
  ...props
}) => {
  const iconClassName = [
    className,
    cursorPointer ? "cursorPointer" : null,
  ]
    .filter(Boolean)
    .join(" ");

  const IconComponent = ICONS[name];

  if (!IconComponent) {
    return <SvgIcon name={name} size={size} className={iconClassName} {...props} />;
  }

  return <IconComponent className={iconClassName} size={size} {...props} />;
};

export default memo(Icon);
